import type { MenuInputOption } from "@saviynt/design-system";
import { createContext, useContext, type ReactNode } from "react";

const defaultUserFieldOptions: MenuInputOption[] = [
  { label: "Username", value: "username", isChecked: true },
  { label: "Email", value: "email" },
  { label: "Employee ID", value: "employeeId" },
];

const defaultAccountFieldOptions: MenuInputOption[] = [
  { label: "name", value: "name", isChecked: true },
  { label: "id", value: "id" },
  { label: "email", value: "email" },
];

interface CorrelationFieldsContextValue {
  userFieldOptions: MenuInputOption[];
  accountFieldOptions: MenuInputOption[];
}

const CorrelationFieldsContext = createContext<CorrelationFieldsContextValue>({
  userFieldOptions: defaultUserFieldOptions,
  accountFieldOptions: defaultAccountFieldOptions,
});

export function CorrelationFieldsProvider({
  userFieldOptions,
  accountFieldOptions,
  children,
}: CorrelationFieldsContextValue & { children: ReactNode }) {
  return (
    <CorrelationFieldsContext.Provider
      value={{ userFieldOptions, accountFieldOptions }}
    >
      {children}
    </CorrelationFieldsContext.Provider>
  );
}

export function useCorrelationFields() {
  return useContext(CorrelationFieldsContext);
}

export function fieldsToOptions(fields: string[]): MenuInputOption[] {
  return fields.map((field) => ({
    label: field,
    value: field,
  }));
}
